module.exports = __webpack_public_path__ + "static/media/Ross.be62e075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Corona/Ross.jpg
// module id = 489
// module chunks = 0